function update_url (url) {
    var obj = { Title: document.title, Url: "#" + url };
    
    if (document.location.hash !== obj.Url)
        window.history.pushState(obj, obj.Title, obj.Url);
}

export default update_url;